export default __webpack_public_path__ + "static/garden_design29-5f2d4607e5a4b2e6eba3da9cb3834e57.webp";